
import { ENDPOINTS } from "./endpoints";
import { DEFAULT_ERROR_PAGE, PAGE_ERROR_MAPPING } from "./errorPageMappings";
import { API_HEADERS, clearSessionAndCookieItem, extractBaseServerV2, extractDomain, MIDDLEWARE } from "./utils";


const fetchWithRetry = async (url: string, options: RequestInit, retries: number = 3, timeoutMs: number = 5000): Promise<Response> => {
  for (let i = 0; i <= retries; i++) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
    try {
      const response = await fetch(url, { ...options, signal: controller.signal });
      clearTimeout(timeoutId);
      return response;
    } catch (error) {
      clearTimeout(timeoutId);
      if (i === retries) throw error;
    }
  }
  throw new Error("Fetch failed");
};

export const fetchLoginData = async ({
  middleware,
  page_name,
}: {
  middleware: string;
  page_name: string;
}) => {
  try {
    const baseServer = extractBaseServerV2(window.location.host);
    const domain = extractDomain();
    const loginUrl = `${middleware || MIDDLEWARE}${
      ENDPOINTS.getUserData
    }?domain=${domain}`;

    const response = await fetchWithRetry(loginUrl, {
      method: "GET",
      headers: {
        ...API_HEADERS,
        baseserver: baseServer,
      },
      credentials: "include",
    });

    if (!response.ok) {
      sessionStorage.removeItem("persist:root");
      sessionStorage.removeItem("searchMode");
      if (response && response.status === 401) {
        const keysToClear = [
          "chatCount",
          "chatServiceEnabled",
          "lastChatFetchTime",
          "userDetails",
          "initialVisit",
          "SESSION_STORAGE_SUBUID",
          "CLEVERTAP_PAGE_TRACKING",
          "dowdowloadsData",
          "dowloadsData",
          "alreadyDownloaded",
          "downloadsInProgress",
          "C",
          "persist:root",
          "searchMode",
        ];

        keysToClear.forEach(clearSessionAndCookieItem);
        localStorage.removeItem("downloadLeader");
        localStorage.removeItem("sessionId");

        // 🔁 Notify all tabs to logout
        const logoutChannel = new BroadcastChannel("logout-channel");
        logoutChannel.postMessage({ type: "LOGOUT" });
        logoutChannel.close();

        window.location.href = `${extractDomain()}?prevUrl=${encodeURIComponent(window.location.href)}`;
      } else {
        sessionStorage.removeItem("persist:root");
        sessionStorage.removeItem("searchMode");
        sessionStorage.setItem("prevUrl", window.location.href);
        window.location.href = `${extractDomain()}`;
      }

      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const loginData = await response.json();
    sessionStorage.setItem("userDetails", JSON.stringify(loginData));

    return loginData;
  } catch (error) {
    console.error("loginError", error);
    return null;
  }
};
 